import { HeaderBar as AppBarComponent, cssVar } from 'metrix-common3';
import styled from 'styled-components';

import configs from './config.json';

const ClientAppBar = styled(AppBarComponent)`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${cssVar.colorLightMode};
    box-shadow: rgb(238 238 238) 0px 2px 2px 0px;
`;

const processConfigForI18n = (config) => {
    const localizedConfig = JSON.parse(JSON.stringify(config));

    if (localizedConfig.links) {
        localizedConfig.links = localizedConfig.links.map((link) => {
            link.label = `AppBar.${link.code}`;
            return link;
        });
    }

    if (localizedConfig.menu) {
        localizedConfig.menu = localizedConfig.menu.map((item) => {
            item.label = `AppBar.${item.code}`;
            return item;
        });
    }

    return localizedConfig;
};

const AppBar = (props) => {
    const _handleClick = (target) => {
        switch (target) {
            case '/home':
                window.location = `${props.context.configuration.corporateWeb}`;
                break;
            case '/logout':
                props.context.doExpireSession();
                window.location = props.context.configuration.clientWeb;
                break;
            case '/policies':
                props.history.push(target);
                break;
            default:
                window.location = `${props.context.configuration.clientWeb}${target}`;
                break;
        }
    };

    let config = configs.filter(
        (config) =>
            config.auth === props.context.authenticated &&
            ((props.context.session && config.userType === props.context.session.userType) ||
                config.userType === 'any'),
    )[0];

    if (config) {
        config = processConfigForI18n(config);
    }

    return (
        <ClientAppBar
            context={props.context}
            userName={props.context.session?.firstName}
            noOfElements={2}
            color={cssVar.colorPrimaryText}
            logoWidth={'177'}
            logoHeight={'50'}
            companyNameColor={cssVar.colorPrimaryText}
            userTypeColor='red'
            brandAvatarColor={cssVar.colorPrimary}
            config={config}
            showLanguageToggle={props.context?.configuration?.isMultiLanguageSupported}
            {...props}
        />
    );
};

export default AppBar;
